import { render } from "./ModifyLoginPassword.vue?vue&type=template&id=478ec8f1&scoped=true"
import script from "./ModifyLoginPassword.vue?vue&type=script&lang=js"
export * from "./ModifyLoginPassword.vue?vue&type=script&lang=js"

import "./ModifyLoginPassword.vue?vue&type=style&index=0&id=478ec8f1&lang=less&scoped=true"

import exportComponent from "/data/web/antpay-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478ec8f1"]])

export default __exports__